"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery, useSubscription } from "@opensea/graphql";
import { useEffect, useMemo, useState } from "react";
import { ContextCurrencyFragment } from "./ContextCurrency.fragment";
import { CurrenciesContext } from "./context";
import { getCurrencyKey, readCurrencyFragment } from "./utils";
const query = graphql(`
    query CurrenciesQuery {
      currencies {
        id
        contractAddress
        ...ContextCurrency
      }
    }
  `, [ContextCurrencyFragment]);
const queryContext = {
  suspense: false
};
const subscriptionQuery = graphql(`
    subscription CurrenciesSubscription($currencies: [ContractIdentifierInput!]) {
      currencies(currencies: $currencies) {
        ...ContextCurrency
      }
    }
  `, [ContextCurrencyFragment]);
export function CurrenciesProvider(t0) {
  const $ = _c(19);
  const {
    initialCurrencies,
    children
  } = t0;
  let t1;
  if ($[0] !== initialCurrencies) {
    t1 = initialCurrencies ?? [];
    $[0] = initialCurrencies;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [currencies, setCurrencies] = useState(t1);
  const [loading, setLoading] = useState(initialCurrencies === undefined);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = initialCurrencies !== undefined;
  let t4;
  if ($[3] !== t3) {
    t4 = {
      query,
      variables: t2,
      pause: t3,
      context: queryContext
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const [t5] = useQuery(t4);
  const {
    data
  } = t5;
  let t6;
  let t7;
  if ($[5] !== data) {
    t6 = function setFetchedCurrencies() {
      if (data) {
        setCurrencies(data.currencies.map(readCurrencyFragment));
        setLoading(false);
      }
    };
    t7 = [data];
    $[5] = data;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  useEffect(t6, t7);
  let t8;
  if ($[8] !== currencies) {
    t8 = currencies.map(_temp);
    $[8] = currencies;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t8) {
    t9 = {
      query: subscriptionQuery,
      variables: {
        currencies: t8
      }
    };
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      onResult: newData => {
        setCurrencies(prev => {
          const currenciesByKey = Object.fromEntries(prev.map(_temp2));
          for (const update of newData.currencies) {
            const updatedCurrency = readCurrencyFragment(update);
            currenciesByKey[getCurrencyKey(updatedCurrency)] = updatedCurrency;
          }
          return Object.values(currenciesByKey);
        });
      },
      batchDelay: 10000,
      batchLeading: false
    };
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  useSubscription(t9, t10);
  let t11;
  let t12;
  if ($[13] !== currencies || $[14] !== loading) {
    t12 = {
      currencies,
      loading
    };
    $[13] = currencies;
    $[14] = loading;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  t11 = t12;
  const value = t11;
  let t13;
  if ($[16] !== children || $[17] !== value) {
    t13 = <CurrenciesContext.Provider value={value}>{children}</CurrenciesContext.Provider>;
    $[16] = children;
    $[17] = value;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  return t13;
}
function _temp2(c_0) {
  return [getCurrencyKey(c_0), c_0];
}
function _temp(c) {
  return {
    chain: c.chainIdentifier,
    address: c.contractAddress
  };
}